import React from 'react';
import { FullViewProps } from '../types';
import { Film } from './Film';
// TODO: Restore video player BI — uncomment useVideoPlayerActionBiLogger and pass onPlaybackAction to Film
// import { useVideoPlayerActionBiLogger } from '../hooks/useVideoPlayerActionBiLogger';

/** Wrapped version of Film that is used for full film deviations */
export const FilmDeviation: React.FC<FullViewProps> = ({ deviation, ...rest }) => {
  // TODO: Restore — const onPlaybackAction = useVideoPlayerActionBiLogger(deviation);
  // return <Film source={deviation} onPlaybackAction={onPlaybackAction} {...rest} />;
  return <Film source={deviation} {...rest} />;
};
FilmDeviation.displayName = 'FilmDeviation';

export default FilmDeviation;
